export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/dare-to-ask-uk.a657ef11.gif","height":595,"width":660,"blurWidth":0,"blurHeight":0};